import { useEffect, useState } from "react";
import { API_GATEWAY_ENDPOINT } from "../../constants/api";

const API_URL =
	API_GATEWAY_ENDPOINT + "area-operacion/get-empresas";

export const useGetCognitoAttributes = () => {
	const [dataEmpresas, setDataEmpresas] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await fetch(API_URL, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						"x-api-key": process.env.REACT_APP_API_KEY,
					}
				});
				const data = await response.json();

				setDataEmpresas(data);
				setLoading(false);
			} catch (error) {
				console.error(error);
				setError(true);
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, []);

	const allEmpresas = Object.keys(dataEmpresas) ?? [];

	function getAreaOperaciones(empresa) {
		return (
			dataEmpresas[empresa]?.map((el) => {
				return {
					idOperacion: el.id_operacion,
					nombreOperacion: el.nombre_operacion,
					idAreaOperacion: el.id_area_operacion,
					nombreAreaOperacion: el.nombre_area_operacion
				};
			}) ?? []
		);
	}

	return { dataEmpresas, allEmpresas, getAreaOperaciones, loading, error };
};
